__turbopack_context__.v({
  "doubleTextContainer": "Navbar-module__R9a9kW__doubleTextContainer",
  "hoverIndicator": "Navbar-module__R9a9kW__hoverIndicator",
  "letterContainer": "Navbar-module__R9a9kW__letterContainer",
  "letterDuplicate": "Navbar-module__R9a9kW__letterDuplicate",
  "letterMain": "Navbar-module__R9a9kW__letterMain",
  "letterWrapper": "Navbar-module__R9a9kW__letterWrapper",
  "navContent": "Navbar-module__R9a9kW__navContent",
  "navLeft": "Navbar-module__R9a9kW__navLeft",
  "navRight": "Navbar-module__R9a9kW__navRight",
  "navbar": "Navbar-module__R9a9kW__navbar",
  "svgBackground": "Navbar-module__R9a9kW__svgBackground",
  "svgContainer": "Navbar-module__R9a9kW__svgContainer",
  "svgIcon": "Navbar-module__R9a9kW__svgIcon",
});
